import React from 'react';
import { Link } from 'react-router-dom';

const AtelierLavage: React.FC = () => {
  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Atelier & Lavage
            </h2>
            
            <h3 className="text-xl font-semibold text-black mb-4">
              Un cadre, un groupe, des roues, des composants périphériques...
            </h3>

            <p className="text-gray-600 mb-6 leading-relaxed">
              Un accompagnement de A à Z dans le montage sur votre futur vélo ! Après avoir 
              sélectionné les pièces avec nos conseils, nos composants les plus adaptés à vos besoins 
              et à votre budget, nous réalisons le montage de votre vélo selon votre pratique 
              (route, gravel ou triathlon), partout en France métropolitaine.
            </p>

            <Link 
              to="/atelier-velo"
              className="inline-block bg-black text-white px-8 py-3 rounded-lg hover:bg-gray-800 transition-colors duration-300 font-medium"
            >
              Je prends rendez-vous
            </Link>
          </div>

          {/* Right Column - Image */}
          <div className="order-1 lg:order-2">
            <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[4/3]">
              <img
                src="/atelier-lavage-podium.png"
                alt="Atelier vélo professionnel"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AtelierLavage;
